import { ApacRadio } from "@apac/ui";
import { useModuleBEM } from "@b2bportal/core-themes";
import styles from "./styles.module.scss";

export const RewardsSelectionCard = ({
  children,
  selected,
  onClick,
  footnote,
  disabled = false,
}) => {
  const [, cn] = useModuleBEM(styles, "RewardsSelectionCard");

  return (
    <div
      className={cn("rewards-account-container", { disabled, selected })}
      onClick={onClick}
    >
      <div className={cn("rewards-content-wrapper")}>
        <div className={cn("rewards-content")}>{children}</div>
        <ApacRadio
          className={cn("rewards-radio-selection")}
          checked={selected}
          disabled={false}
          onChange={onClick}
        />
      </div>
      {footnote}
    </div>
  );
};
